import { AuthService } from './AuthService';
import { FirebaseAuthService } from './FirebaseAuthService';

// Validate Firebase config
const hasFirebaseConfig = !!(
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_PROJECT_ID
);

// Create and export the Firebase auth service instance
if (!hasFirebaseConfig) {
  throw new Error(
    'Firebase configuration is missing. Please check your .env file and ensure all required Firebase variables are set.'
  );
}

export const authService: AuthService = new FirebaseAuthService();

// Export types and classes for direct usage if needed
export type { AuthService };
export { FirebaseAuthService };
